/**
 * Primary front-end script.
 *
 * Primary JavaScript file. Any includes or anything imported should
 * be filtered through this file and eventually saved back into the
 * `/dist/js/app.js` file.
 *
 * @package   Retouch
 * @author    Bengal Studio <bhoot.biswas@gmail.com>
 * @copyright 2018 Bengal Studio
 * @license   https://www.gnu.org/licenses/gpl-2.0.html GPL-2.0-or-later
 * @link      https://bengal-studio.com/themes/retouch
 */

/**
 * A simple immediately-invoked function expression to kick-start
 * things and encapsulate our code.
 *
 * @since  1.0.0
 * @access public
 * @return void
 */
(function($) {

	"use strict";

    function onMouseOut(event) {
        // If the mouse is near the top of the window, show the popup
        // Also, do NOT trigger when hovering or clicking on selects
        if (
            event.clientY < 50 &&
            event.relatedTarget == null &&
            event.target.nodeName.toLowerCase() !== 'select') {
            // Remove this event listener
            document.removeEventListener("mouseout", onMouseOut);

            // Show the popup
            $('#exit-modal-xl').modal();
        }
    }

	// javascript code here. i.e.: $(document).ready( function(){} );
	$(document).ready(function() {
		// Add smooth scrolling to all links
		$("a").on('click', function(event) {
            // Store hash
            var hash = this.hash;

			// Make sure this.hash has a value before overriding default behavior
			if ((this.hash !== "") && $(hash).length) {
				// Prevent default anchor click behavior
				event.preventDefault();

				// Using jQuery's animate() method to add smooth page scroll
				// The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
				$('html, body').animate({
					scrollTop: $(hash).offset().top
				}, 800, function() {

					// Add hash (#) to URL when done scrolling (default click behavior)
					window.location.hash = hash;
				});
			} // End if
		});
	});

    document.addEventListener("mouseout", onMouseOut);

})(jQuery);



// WEBPACK FOOTER //
// ./resources/js/app.js